/**
 * Wishlist Hero modal: hide per-card Add to cart, inject ATC-styled button.
 * Label/style match PDP ProductSubmitButton ("Legg i handlekurv").
 * On click: load variant metafields; if is_bundle, add components with the
 * same line-item property schema as PDP buy-buttons.liquid.
 */
(function () {
  'use strict';

  var MARK = 'data-slk-wlh-show-info';
  var BTN_CLASS = 'slk-wlh-show-info-btn';
  var HIDDEN_CLASS = 'slk-wlh-atc-hidden';

  function getAddToCartLabel() {
    if (window.FoxTheme && FoxTheme.strings && FoxTheme.strings.addToCart) {
      return FoxTheme.strings.addToCart;
    }
    return 'Legg i handlekurv';
  }

  function setButtonLabel(btn, text) {
    var textEl = btn.querySelector('.btn__text');
    if (textEl) {
      textEl.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function getSpinnerHtml() {
    return (
      '<div class="loading__spinner hidden">' +
        '<svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
          '<circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>' +
        '</svg>' +
      '</div>'
    );
  }

  function setButtonLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('btn--loading');
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('btn--loading');
    }
  }

  function norm(text) {
    return String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isAddAllOrOther(text) {
    return /legg\s*alt|add\s*all|fjern|remove|logg\s*inn|log\s*in|login|vis\s*info|show\s*info/.test(text);
  }

  function isAddToCart(text) {
    if (!text || isAddAllOrOther(text)) return false;
    return (
      /legg\s*til\s*i\s*handlekurven/.test(text) ||
      /legg\s*til/.test(text) ||
      /add\s*to\s*cart/.test(text) ||
      /handlekurv/.test(text)
    );
  }

  function findAddToCartButton(card) {
    var nodes = card.querySelectorAll('button, a.MuiButton-root, .MuiButtonBase-root');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains(BTN_CLASS)) continue;
      if (isAddToCart(norm(el.textContent))) return el;
    }
    return null;
  }

  function getProductInfo(card) {
    var link =
      card.querySelector('a.wishlist-hero-list-card-header-product-name[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    var handle = '';
    var name = '';
    var variantId = null;

    if (link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      if (match) {
        try {
          handle = decodeURIComponent(match[1]);
        } catch (e) {
          handle = match[1];
        }
      }
      var vm = href.match(/[?&]variant=(\d+)/);
      if (vm) variantId = parseInt(vm[1], 10);
      name = (link.textContent || '').trim();
    }

    if (!name) {
      var title =
        card.querySelector('.MuiCardHeader-title') ||
        card.querySelector('.wishlist-hero-list-card-header') ||
        card.querySelector('.MuiTypography-root');
      if (title) {
        name = (title.textContent || '').trim().replace(/\s+\d{1,2}\s+\w+\s+\d{4}\s*$/, '').trim();
      }
    }

    return {
      name: name || '(unknown)',
      handle: handle || '(unknown)',
      variantId: variantId
    };
  }

  function pickVariant(variants, preferredVariantId) {
    if (!variants || !variants.length) return null;
    if (preferredVariantId) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(preferredVariantId)) {
          return variants[i];
        }
      }
    }
    return variants[0];
  }

  function buildSingleCartItem(variant, quantity) {
    var id = variant && variant.id;
    if (!id) {
      return { ok: false, error: 'Missing variant id for single product add' };
    }
    return {
      ok: true,
      items: [
        {
          id: id,
          quantity: parseInt(quantity, 10) || 1
        }
      ]
    };
  }

  function shopRoot() {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function parseJsonPayload(text) {
    var t = String(text || '').replace(/^\uFEFF/, '').trim();
    try {
      return JSON.parse(t);
    } catch (e) {
      var start = t.indexOf('{');
      var end = t.lastIndexOf('}');
      if (start >= 0 && end > start) {
        return JSON.parse(t.slice(start, end + 1));
      }
      throw e;
    }
  }

  function fetchVariantMetafields(handle) {
    var url = shopRoot() + 'products/' + encodeURIComponent(handle) + '?view=slk-metafields-api';
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      return response.text().then(function (text) {
        if (!response.ok) {
          throw new Error('Metafields request failed (' + response.status + ')');
        }
        return parseJsonPayload(text);
      });
    });
  }

  function mfValue(metafields, key) {
    if (!metafields) return null;
    var entry = metafields['custom.' + key] || metafields[key];
    if (!entry) return null;
    return entry.value != null ? entry.value : null;
  }

  function isTruthyBundle(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function resolveVariantId(item) {
    if (item == null) return null;
    if (typeof item === 'number' && item > 0) return item;
    if (typeof item === 'string') {
      var gid = item.match(/ProductVariant\/(\d+)/);
      if (gid) return parseInt(gid[1], 10);
      var asNum = parseInt(item, 10);
      return asNum > 0 ? asNum : null;
    }
    if (typeof item === 'object') {
      if (item.id != null) {
        if (typeof item.id === 'number') return item.id;
        var fromId = resolveVariantId(String(item.id));
        if (fromId) return fromId;
      }
      if (item.variants && item.variants[0] && item.variants[0].id) {
        return resolveVariantId(item.variants[0].id);
      }
    }
    return null;
  }

  /**
   * Build cart payload identical to PDP buy-buttons.liquid:
   * - all line-item properties as strings
   * - _bundle_products_data = JSON array of component variant IDs only
   * - quantity = bundle_quantity * user_quantity
   */
  function buildBundleCartItems(productData, parentVariant, userQuantity) {
    var metafields = parentVariant.metafields || {};
    var bundleProducts = mfValue(metafields, 'bundle_products');
    var bundleQuantities = mfValue(metafields, 'bundle_quantities');
    var bundleDiscount = mfValue(metafields, 'bundle_discount');

    if (!Array.isArray(bundleProducts) || bundleProducts.length === 0) {
      return { ok: false, error: 'No bundle_products found on variant' };
    }

    userQuantity = parseInt(userQuantity, 10) || 1;

    var bundleId =
      'bundle-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    var parentVariantId = parentVariant.id;

    // Same as PDP: store only component variant IDs (not full objects)
    var componentIds = [];
    for (var c = 0; c < bundleProducts.length; c++) {
      var cid = resolveVariantId(bundleProducts[c]);
      if (cid) componentIds.push(cid);
    }
    var bundleProductsData = JSON.stringify(componentIds);

    var items = [];

    for (var i = 0; i < bundleProducts.length; i++) {
      var component = bundleProducts[i];
      var componentVariantId = resolveVariantId(component);
      if (!componentVariantId) {
        return {
          ok: false,
          error: 'Could not resolve variant id for bundle item index ' + i,
          item: component
        };
      }

      var bundleQuantity = 1;
      if (
        Array.isArray(bundleQuantities) &&
        bundleQuantities[i] != null &&
        bundleQuantities[i] !== ''
      ) {
        var parsedQty = parseInt(bundleQuantities[i], 10);
        if (parsedQty > 0) bundleQuantity = parsedQty;
      }

      var finalQuantity = bundleQuantity * userQuantity;

      var properties = {
        _bundle_id: bundleId,
        _is_bundle: 'true',
        _variant_id: parentVariantId.toString(),
        _bundle_quantity: bundleQuantity.toString(),
        _user_quantity: userQuantity.toString(),
        _product_title: (component && component.title) || 'Bundle Variant',
        _product_id: componentVariantId.toString(),
        _bundle_products_data: bundleProductsData,
        _bundle_name: productData.title || ''
      };

      if (bundleDiscount != null && bundleDiscount !== '' && bundleDiscount !== false) {
        properties._bundle_discount = bundleDiscount.toString();
        properties._discount_value = bundleDiscount.toString();
      }

      items.push({
        id: componentVariantId,
        quantity: finalQuantity,
        properties: properties
      });
    }

    return { ok: true, items: items };
  }

  function addItemsToCart(items) {
    return items.reduce(function (promise, item) {
      return promise.then(function (results) {
        return fetch(shopRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: item.id,
            quantity: item.quantity,
            properties: item.properties
          })
        }).then(function (response) {
          return response.json().then(function (body) {
            results.push({ ok: response.ok, item: item, body: body });
            return results;
          });
        });
      });
    }, Promise.resolve([]));
  }

  function isCartPage() {
    if (window.Shopify && Shopify.Request && Shopify.Request.pageType === 'cart') {
      return true;
    }
    if (document.body && document.body.classList.contains('template-cart')) {
      return true;
    }
    var path = (window.location.pathname || '').replace(/\/+$/, '');
    return /\/cart$/i.test(path);
  }

  function refreshCartUi() {
    // Cart page: drawer is usually off — reload so line items / prices update.
    if (isCartPage()) {
      window.location.reload();
      return Promise.resolve(null);
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var cartDrawerSectionId = cartDrawer
      ? cartDrawer.getAttribute('data-section-id')
      : null;

    var cartPromise = fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json();
    });

    var sectionPromise = cartDrawerSectionId
      ? fetch(shopRoot() + '?section_id=' + encodeURIComponent(cartDrawerSectionId), {
          credentials: 'same-origin'
        }).then(function (r) {
          return r.text();
        })
      : Promise.resolve(null);

    return Promise.all([cartPromise, sectionPromise]).then(function (pair) {
      var cartData = pair[0];
      var sectionHtml = pair[1];
      var sections = {};

      if (sectionHtml && cartDrawerSectionId) {
        var parser = new DOMParser();
        var parsed = parser.parseFromString(sectionHtml, 'text/html');
        var sectionEl = parsed.querySelector('#shopify-section-' + cartDrawerSectionId);
        if (sectionEl) {
          sections['sections--' + cartDrawerSectionId + '__cart-drawer'] = sectionEl.outerHTML;
        }
      }

      var cartJson = Object.assign({}, cartData, { sections: sections });
      window.currentCartData = cartJson;
      window.currentCartItems = cartJson.items || [];

      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: cartJson
        });
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartJson } })
      );
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: { product: { status: 'success' }, cart: cartJson }
        })
      );

      if (cartDrawer && typeof cartDrawer.show === 'function') {
        try {
          cartDrawer.show();
        } catch (e) {}
      }

      return cartJson;
    });
  }

  function onShowInfoClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var btn = event.currentTarget;
    if (btn.disabled || btn.classList.contains('btn--loading')) return;

    var card = btn.closest('.wishlist-hero-list-card');
    if (!card) return;

    var info = getProductInfo(card);
    console.log('[Wishlist Show Info]', info);

    if (!info.handle || info.handle === '(unknown)') {
      console.warn('[Wishlist Show Info] No product handle');
      return;
    }

    setButtonLoading(btn, true);

    fetchVariantMetafields(info.handle)
      .then(function (data) {
        var variants = (data && data.variants) || [];
        console.log('[Wishlist Show Info] Variant metafields', variants);

        var variant = pickVariant(variants, info.variantId);
        if (!variant) {
          throw new Error('No variants returned for ' + info.handle);
        }

        var isBundle = isTruthyBundle(mfValue(variant.metafields, 'is_bundle'));
        console.log('[Wishlist Show Info] is_bundle:', isBundle);

        var built;
        if (isBundle) {
          // Bundle: add all component variants (same payload as PDP)
          built = buildBundleCartItems(data, variant, 1);
        } else {
          // Non-bundle: add the product variant itself
          built = buildSingleCartItem(variant, 1);
        }

        console.log('[Wishlist Show Info] Cart payload', built);

        if (!built.ok) {
          throw new Error(built.error || 'Failed to build cart items');
        }

        return addItemsToCart(built.items).then(function (results) {
          var successCount = results.filter(function (r) {
            return r.ok;
          }).length;
          console.log('[Wishlist Show Info] Cart add results', results);

          if (successCount === 0) {
            throw new Error('No items were added to cart');
          }

          return refreshCartUi().then(function () {
            return {
              successCount: successCount,
              total: results.length,
              isBundle: isBundle
            };
          });
        });
      })
      .then(function (result) {
        if (result) {
          console.log(
            '[Wishlist Show Info] Added ' +
              result.successCount +
              '/' +
              result.total +
              (result.isBundle ? ' bundle items' : ' item(s)')
          );
        }
      })
      .catch(function (err) {
        console.error('[Wishlist Show Info] Failed', err);
      })
      .finally(function () {
        setButtonLoading(btn, false);
      });
  }

  function ensureShowInfoButton(card, atcButton) {
    if (card.querySelector('.' + BTN_CLASS)) return;

    var label = getAddToCartLabel();
    var btn = document.createElement('button');
    btn.type = 'button';
    // Same classes/markup as PDP ProductSubmitButton (buy-buttons.liquid)
    btn.className = 'product-form__submit btn btn--primary ' + BTN_CLASS;
    btn.setAttribute('aria-label', label);
    btn.innerHTML =
      '<span class="btn__text">' + label + '</span>' + getSpinnerHtml();
    btn.addEventListener('click', onShowInfoClick);

    if (atcButton && atcButton.parentNode) {
      atcButton.parentNode.insertBefore(btn, atcButton.nextSibling);
    } else {
      card.appendChild(btn);
    }
  }

  function enhanceCard(card) {
    if (!card || card.nodeType !== 1) return;

    var atc = findAddToCartButton(card);
    if (atc) {
      atc.classList.add(HIDDEN_CLASS);
      atc.setAttribute('aria-hidden', 'true');
      atc.setAttribute('tabindex', '-1');
    }

    ensureShowInfoButton(card, atc);
    card.setAttribute(MARK, '1');
  }

  function enhanceAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll
      ? scope.querySelectorAll('.wishlist-hero-list-card')
      : [];

    if (scope.classList && scope.classList.contains('wishlist-hero-list-card')) {
      enhanceCard(scope);
    }

    for (var i = 0; i < cards.length; i++) {
      enhanceCard(cards[i]);
    }
  }

  var _active = false;

  function activate() {
    enhanceAll(document);
    if (_active) return;
    _active = true;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('wishlist-hero-list-card')) {
            enhanceCard(node);
          } else if (node.querySelectorAll) {
            enhanceAll(node);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    var n = 0;
    var iv = setInterval(function () {
      enhanceAll(document);
      if (++n > 25) clearInterval(iv);
    }, 300);
  }

  document.addEventListener('wishlist-hero-wishlist-sdk-ready', activate);
  document.addEventListener('click', function (e) {
    var t =
      e.target.closest &&
      e.target.closest(
        'a[href="#hero-wishlist"], a[href*="hero-wishlist"], .wishlist-hero-header-icon'
      );
    if (t) activate();
  });
  window.addEventListener('hashchange', function () {
    if (location.hash.indexOf('wishlist') !== -1 || location.hash === '#hero-wishlist') {
      activate();
    }
  });

  function onReady() {
    if (
      location.hash.indexOf('wishlist') !== -1 ||
      location.hash === '#hero-wishlist' ||
      document.querySelector('.wishlist-hero-list-card, .MuiDialog-root')
    ) {
      activate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
